import { render, staticRenderFns } from "./FaturamentoListFiltro.vue?vue&type=template&id=f80906fa"
import script from "./FaturamentoListFiltro.vue?vue&type=script&lang=js"
export * from "./FaturamentoListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports